import { render, staticRenderFns } from "./AboutPeajContent.vue?vue&type=template&id=848b3dc4&scoped=true&lang=html"
import script from "./AboutPeajContent.vue?vue&type=script&lang=js"
export * from "./AboutPeajContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848b3dc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('848b3dc4')) {
      api.createRecord('848b3dc4', component.options)
    } else {
      api.reload('848b3dc4', component.options)
    }
    module.hot.accept("./AboutPeajContent.vue?vue&type=template&id=848b3dc4&scoped=true&lang=html", function () {
      api.rerender('848b3dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AboutPeajContent.vue"
export default component.exports